import { Component } from 'vue'
import type { RouteRecordRaw, RouteMeta } from 'vue-router'

export interface AppRouteMeta extends RouteMeta {
  title: string
}
/**
 * @desc: 路由接口，继承RouteRecordRaw类型，使meta必填
 * */
// @ts-ignore
export interface AppRouteRecordRaw extends Omit<RouteRecordRaw, 'meta'> {
  meta: AppRouteMeta // 必填
  iframeComponent?: Component
  children?: AppRouteRecordRaw[]
}

export enum CustomEnum {
  Name = 'CustomPage' // 自定义菜单名
}
